import { render, staticRenderFns } from "./reportDetail.vue?vue&type=template&id=2a6cd788&scoped=true&"
import script from "./reportDetail.vue?vue&type=script&lang=js&"
export * from "./reportDetail.vue?vue&type=script&lang=js&"
import style1 from "./reportDetail.vue?vue&type=style&index=1&id=2a6cd788&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6cd788",
  null
  
)

export default component.exports